
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1tif4_153",
  "button": "awsui_button_vjswe_1tif4_157",
  "variant-normal": "awsui_variant-normal_vjswe_1tif4_206",
  "disabled": "awsui_disabled_vjswe_1tif4_224",
  "variant-primary": "awsui_variant-primary_vjswe_1tif4_231",
  "variant-link": "awsui_variant-link_vjswe_1tif4_256",
  "variant-icon": "awsui_variant-icon_vjswe_1tif4_281",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1tif4_306",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1tif4_331",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1tif4_356",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1tif4_385",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1tif4_410",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1tif4_435",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1tif4_465",
  "button-no-text": "awsui_button-no-text_vjswe_1tif4_557",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1tif4_561",
  "full-width": "awsui_full-width_vjswe_1tif4_564",
  "icon-left": "awsui_icon-left_vjswe_1tif4_586",
  "icon-right": "awsui_icon-right_vjswe_1tif4_591",
  "icon": "awsui_icon_vjswe_1tif4_586",
  "link": "awsui_link_vjswe_1tif4_610",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1tif4_610"
};
  